/**
 * @file Default subscribe and unsubscribe functionality
 * @author Heino Lenting
 */
/**
 * Default subscribe and unsubscribe functionality
 */
var SubscriptionPool = /** @class */ (function () {
    /**
     * Constructs a subscriber
     */
    function SubscriptionPool() {
        /** The actual subscription pool */
        this.subscriptions = []; // { [s: string]: ISubscription; } = {};
    }
    SubscriptionPool.prototype.countSubscriptions = function () {
        return this.subscriptions.length;
    };
    /**
     * Add a subscription to the pool
     * @param key The key of the subscription
     * @param subscription The subscription
     */
    SubscriptionPool.prototype.add = function (subscription) {
        this.subscriptions.push(subscription);
        // If the subscription already exist give a warning and stop
        // if (this.subscriptions[key]) {
        //     console.warn('A subscription with key "'
        //         + key
        //         + '" already exists. Please re-use existing subscription or unsubscribe first? (Unsubscribing previous one) ');
        //     this.unsubscribe(key);
        // }
        // // Check if subscription is given
        // if (!subscription) {
        //     console.warn('No subscription is given for key "' + key + '"');
        //     return;
        // }
        // // Add to subscriptions collection
        // this.subscriptions[key] = subscription;
    };
    /**
     * Get a subscription via key
     * * @param key The key of the subscription to get
     */
    // public get(key: string): ISubscription {
    //     // If the subscription not exists give a warning
    //     if (!this.subscriptions[key]) {
    //         console.warn('A subscription with key "' + key + '" does not exist');
    //         return undefined;
    //     }
    //     // Return the subscription
    //     return this.subscriptions[key];
    // }
    /**
     * Unsubscripe given subscription via key
     * @param key The key of the subscription to unsubscribe
     */
    // public unsubscribe(key: string) {
    //     // If subscription exits unsubscribe!
    //     if (this.subscriptions[key]) {
    //         this.subscriptions[key].unsubscribe();
    //         // Delete the subscription
    //         delete this.subscriptions[key];
    //     }
    // }
    /**
     * Unsubscripe all known subscriptions
     */
    SubscriptionPool.prototype.unsubscribeAll = function () {
        this.subscriptions.forEach(function (subscription) {
            subscription.unsubscribe();
        });
        // // Run through subscription
        // Object.keys(this.subscriptions).forEach(key => {
        //     this.subscriptions[key].unsubscribe();
        // });
        // // Make subscription pool empty
        // this.subscriptions = {};
    };
    return SubscriptionPool;
}());
export { SubscriptionPool };
